import s from './styles.module.css'

export default function FsaBadge() {
  return (
    <div className={s.fsaWrapper}>
      <span className={s.fsa}>FSA/HSA Eligible</span>
    </div>
  )
}
